<template>
  <custom-callout
    border-color="orange"
    class="mb-3 custom-callout"
    :has-toggle="false"
  >
    <validation-observer ref="absenceInterventionPlanRef" novalidate tag="form">
      <icon-view
        class="icon-view__extended"
        icon="fas fa-flag"
        icon-background="#fff"
        icon-color="#FF7058"
        icon-size="16px"
        title="Documentar Ausencia"
      />

      <div class="row mt-4">
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-date-picker
              v-model="model.date"
              class-container="w-100"
              custom-error-msg="Favor de seleccionar la fecha."
              :error="errors[0]"
              label="Fecha:"
              :max-date="maxDate"
              :min-date="minDate"
              placeholder="DD/MM/YYYY"
            />
          </validation-provider>
        </div>
        <div class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-drop-down
              id="absenceReasonDD"
              v-model="model.absenceReason"
              custom-error-msg="Favor de seleccionar la razón de Ausencia."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Razón de Ausencia:"
              :options="absenceReasons"
              placeholder="Seleccione"
            />
          </validation-provider>
        </div>
        <div v-if="otherAbsenceReasonSelected" class="col-md-4">
          <validation-provider v-slot="{ errors }" rules="required">
            <custom-input
              id="otherAbsence"
              v-model="model.otherAbsenceReason"
              custom-error-msg="Favor de completar el campo."
              :error="errors[0]"
              fieldkey="id"
              fieldname="name"
              label="Especifique Razón:"
              maxlength="50"
              placeholder="Razón"
            />
          </validation-provider>
        </div>
      </div>

      <div class="d-flex justify-content-end align-items-center mt-4 mb-2">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3 px-3"
          @click="onCancelHandler"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success px-3"
          @click="onSaveHandler"
        />
      </div>
    </validation-observer>
  </custom-callout>
</template>

<script>
import CustomCallout from 'custom-callout';
import IconView from 'icon-view';
import CustomInput from 'CustomInput';
import ActionButton from 'ActionButton';
import CustomDropDown from 'custom-drop-down';
import CustomDatePicker from 'custom-date-picker';

const OTHER_REASON_ID = 1;

export default {
  name: 'AbsenceInterventionPlan',
  components: {
    CustomCallout,
    IconView,
    CustomInput,
    CustomDropDown,
    CustomDatePicker,
    ActionButton,
  },
  props: {
    linkedDate: {
      type: String,
      default: null,
    },
    absenceReasons: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    model: {
      date: null,
      absenceReason: null,
      otherAbsenceReason: null,
    },
  }),
  computed: {
    minDate() {
      const minDateWithoutTime = this.linkedDate.split('T')[0];
      return new Date(minDateWithoutTime);
    },
    maxDate() {
      const currentDate = new Date();
      let currentDateUTC = new Date(
        Date.UTC(
          currentDate.getUTCFullYear(),
          currentDate.getUTCMonth(),
          currentDate.getUTCDate()
        )
      );

      currentDateUTC = currentDateUTC.toISOString().split('T')[0]; // Obtener solo la fecha sin la hora

      return currentDateUTC;
    },
    otherAbsenceReasonSelected() {
      return this.model.absenceReason?.id == OTHER_REASON_ID;
    },
  },
  watch: {
    'model.absenceReason': {
      deep: true,
      handler() {
        this.model.otherAbsenceReason = null;
      },
    },
  },
  methods: {
    onCancelHandler() {
      this.$emit('on-cancel');
    },
    async onSaveHandler() {
      const isValid = await this.$refs.absenceInterventionPlanRef.validate();
      if (!isValid) return;

      this.$emit('on-save', this.model);
    },
  },
};
</script>
